import { Controller, useFormContext } from "react-hook-form";
import { Checkbox, Form } from "semantic-ui-react";

import type { FieldValues, Path } from "react-hook-form";
import type { CheckboxProps, FormFieldProps } from "semantic-ui-react";

type NestedPath<T> =
  | (keyof T & string)
  | {
      [K in keyof T & string]: NonNullable<T[K]> extends object ? `${K}.${keyof NonNullable<T[K]> & string}` : never;
    }[keyof T & string];

type TypeFormCheckbox<T extends FieldValues> = {
  name: NestedPath<T>;
  disabled?: boolean;
  label?: string | React.ReactNode;
  checkboxProps?: CheckboxProps;
  formFieldProps?: FormFieldProps;
  onChange?: (value: boolean) => void;
};

export const FormCheckbox = <T extends FieldValues>({ name, checkboxProps, formFieldProps, onChange, disabled = false, label }: TypeFormCheckbox<T>) => {
  const methods = useFormContext<T>();

  return (
    <Controller
      name={name as Path<T>}
      control={methods.control}
      render={({ field, fieldState: { invalid, isTouched } }) => (
        <Form.Field {...formFieldProps} error={invalid && isTouched}>
          <Checkbox
            {...checkboxProps}
            checked={checkboxProps?.checked !== undefined ? checkboxProps.checked : (field.value ?? false)}
            label={label}
            disabled={disabled}
            onChange={(_, data) => {
              field.onChange(data.checked);
              onChange?.(data.checked === true);
            }}
          />
        </Form.Field>
      )}
    />
  );
};
